const buildFormData = (data: unknown, formData?: FormData, parentKey?: string): FormData => {
    const fd = formData || new FormData();

    if (
        data &&
        typeof data === 'object' &&
        !(data instanceof Date) &&
        !(data instanceof File) &&
        (!(data instanceof Blob) || typeof data !== 'string')
    ) {
        Object.keys(data as Record<string, unknown>).forEach((key: string) => {
            buildFormData(
                (data as Record<string, unknown>)[key],
                fd,
                parentKey ? `${parentKey}[${key}]` : key,
            );
        });
    } else {
        const value = data == null ? '' : data;
        if (parentKey) {
            fd.append(parentKey, value as string | Blob);
        }
    }
    return fd;
};

export { buildFormData };
